/** @jsx jsx */

import React, {
  Fragment as _,
  memo,
  useMemo,
  useState,
  useContext,
} from 'react';
import { css, jsx } from '@emotion/core';
import EditableText from 'components/lib/EditableText';
import { colors } from 'styles/variables';
import getTempTextImageData from 'services/getTempTextImageContinueBtnData';
import expandBlock from 'services/apiHelpers/expandBlock';
import renderBlock from 'services/apiHelpers/renderBlock';
import { Row, Column, Button, Box } from '@chameleoncreator/creator-ui';
import Image from 'components/lib/Image';
import Video from 'components/lib/Video';
import SVG from 'components/lib/SVG';
import ContinueBtn from 'components/lib/ContinueBtn/continueBtn_v2';
import Container from 'components/Layouts/ContainerLogical';
import { connect } from 'react-redux';
import { interactionContext } from './interactionContext';
import Media from 'components/lib/Media';
import { Block } from '@chameleoncreator/creator-app';
import getBlockById from 'services/apiHelpers/getBlockById';
import shouldUpdate from 'services/shouldUpdate';
import IELayout from 'components/Layouts/IELayout';
import Assessment from './Assessment';
import AssessmentIntroduction from './AssessmentIntroduction';
import AssessmentQuestion from './AssessmentQuestion';
import AssessmentResults from './AssessmentResults';

const { lPink, lGrey0, lGrey1, lGrey2 } = colors;

const SingleColumnLayout = Row.bind({}) as any;
SingleColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'column',
};

const TwoColumnLayout = Row.bind({}) as any;
TwoColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'row',
};

const Components = {
  Row,
  Column,
  Text: EditableText,
  // FullPageText: ({ children, ...props }) => (
  //   <div
  //     css={css`
  //       padding: 10px;
  //     `}
  //   >
  //     {children}

  //     <TermsAndConditions
  //     // onClick={() => {
  //     //   console.log('terms met');
  //     // }}
  //     />
  //   </div>
  // ),
  Assessment,
  AssessmentIntroduction,
  AssessmentQuestions: ({ children, ...props }) => children,
  AssessmentQuestion,
  AssessmentResults,
  Image,
  TwoColumnLayout,
  SingleColumnLayout,
  ContinueButton: ContinueBtn,
  Video,
  SVG,
  Media,
  ...IELayout(interactionContext),
};

const AssessmentDisplay = memo((props: any) => {
  const interactionBlock = getBlockById(props.blockId);

  return (
    <Container
      id={interactionBlock.id}
      key={interactionBlock.id}
      {...interactionBlock.props}
      {...props}
    >
      <interactionContext.Provider
        value={{ ...interactionBlock, updateItemsSeen: null } as any}
      >
        {(interactionBlock.children as Block[]).map(child => {
          return renderBlock(child, Components);
        })}
      </interactionContext.Provider>
    </Container>
  );
});
// shouldUpdate

export default AssessmentDisplay;
